

<div class="row g-3">
    <div class="col-sm-12">
            <ed-table 
                title="Détail des temps passés"
                [dataSource]="monthlyTimeData" 
                [displayedColumns]="monthlyTimeColumns"
                (onRowClick)="goToContributor($event)"
                [sortInfo]="{field: 'total', order: -1}"
                >
            </ed-table>
    </div>
</div>
